import React from "react";
import "./app.css";
const TermsPreview = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="card-body">
      <h3
           className="title-color"
              style={{ direction: activetab === "arabic" && "rtl",textAlign:"center" }}
            >
              {activetab === "english"
                ? cardData?.title
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_title
                : activetab === "arabic"
                ? cardData?.arabic_title
                : activetab === "bahasa"
                ? cardData?.bahasa_title
                : cardData?.traditional_chinese_title}
            </h3>
          <h5 className="subtitle-color" style={{ direction: activetab === "arabic" && "rtl",textAlign:"center" }}>
               {activetab === "english"
                ? cardData?.sub_title
                : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_sub_title
                : activetab === "bahasa"
                ? cardData?.bahasa_sub_title
                : cardData?.traditional_chinese_sub_title} 
          </h5> 
      </div>
        <div style={{border:"1px solid black",padding:"50px",margin:"10px",borderRadius:"10px"}}>
        <div
          dangerouslySetInnerHTML={{
            __html: (activetab === "english"
              ? cardData?.description
              : activetab === "simplified_chinese"
                ? cardData?.simplified_chinese__description
                : activetab === "bahasa"
                  ? cardData?.bahasa_description
                  : cardData?.traditional_chinese_description)
          }}
        />
      </div>

    </div>
  );
};

export default TermsPreview;
